import { z } from 'zod'
import { SuccessEnvelope, UserPublic } from './common.js'

export const SignupResponse = z.object({ message: z.string() })
export const VerifySignupOtpResponse = z.object({ setupToken: z.string() })
export const VerifyResetOtpResponse = z.object({ resetToken: z.string() })
export const AuthSuccessResponse = SuccessEnvelope(
  z.object({ user: UserPublic }),
)
export const LogoutResponse = z.object({
  success: z.literal(true),
  message: z.string(),
})
export const ForgotPasswordResponse = z.object({ message: z.string() })
export const ResetPasswordResponse = z.object({ message: z.string() })
export const ResendOtpResponse = z.object({ message: z.string() })
